import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import SkipTheCounterFlow from './SkipTheCounterFlow';

const SkipTheCounterFlowWrapper = (props) => (
  <Router basename='/'>
    <SkipTheCounterFlow {...props} />
  </Router>
);

export default SkipTheCounterFlowWrapper;
